import {
  AdminInput,
  Button,
  ErrorToast,
  Modal,
  PropsModal,
} from '@vgrubs/components';
import { Provider } from 'components/src/types/shared.types';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useParams } from 'react-router';

export const ImportMenuModal = ({
  importMenuModal,
  closeModal,
  setProviderToImport,
  setUrlToScrape,
}: PropsModal & {
  importMenuModal: boolean;
  setProviderToImport: Dispatch<SetStateAction<string | null>>;
  setUrlToScrape: Dispatch<SetStateAction<string | null>>;
}) => {
  const [importProvider, setImportProvider] = useState<
    string | Provider | null
  >('Menu Link');

  const [menuLink, setMenuLink] = useState('');

  const { provider } = useParams() as { provider: Provider };

  async function handleImportMenu() {
    closeModal?.();

    setProviderToImport(importProvider);
    if (importProvider === 'Menu Link') return setUrlToScrape(menuLink);
  }

  useEffect(() => {
    setImportProvider('Menu Link');
    setMenuLink('');
  }, [importMenuModal]);

  const handleImportToButton = () => {
    if (!importProvider) return ErrorToast('Please Select Provider.');
    if (importProvider === 'Menu Link' && !menuLink)
      return ErrorToast('Please Enter Menu Link.');
    handleImportMenu();
  };

  const providersDelivery = {
    UBER_EATS: Provider.ubereats,
    GRUBHUBPOS: Provider.grubhub,
  };

  const providersUnified = {
    UBER_EATS: Provider.ubereats,
    GRUBHUBPOS: Provider.grubhubPos,
    DELIVERY: Provider.delivery,
  };

  const providersToImportFrom =
    provider === Provider.gloriafood ? providersUnified : providersDelivery;

  return (
    <Modal
      header="Import Menu"
      isOpen={importMenuModal}
      closeModal={closeModal}
      logo={false}
      overflow="visible"
    >
      {/* <AdminCustomProviderSelect
        value={importProvider}
        onChange={(value) => {
          setImportProvider(value as string);
        }}
        label="Choose provider to copy from or enter link"
        providerArray={providersToImportFrom}
        additionalOptions={['Menu Link']}
      /> */}

      {importProvider === 'Menu Link' && (
        // <Div $mt="16">
        <AdminInput
          value={menuLink}
          onChange={({ target }) => setMenuLink(target.value)}
          placeholder="Enter the menu link"
          $textCenter
          label="Menu Link"
        />
        // </Div>
      )}
      <Button $selected $w="100%" $mt="32" onClick={handleImportToButton}>
        Submit
      </Button>
    </Modal>
  );
};
